import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface GenerateCrmSnapshotPayload {
  apiKey: string;
}

export interface GenerateCrmSnapshotResponse {
  success: boolean;
  snapshotId: string;
  status: string;
  message: string;
  subscriptionId: string;
}

async function generateCrmSnapshot(
  payload: GenerateCrmSnapshotPayload,
  auth: Authentication
): Promise<GenerateCrmSnapshotResponse> {
  try {
    return await HttpClient.post('/integrations/contacts/snapshot', payload, auth.token, false, {
      'x-api-key': payload.apiKey,
    });
  } catch (e: any) {
    const errorMessage = e.message || 'Unknown error';
    throw new GenerateCrmSnapshotFailure(errorMessage, 'snapshot-error');
  }
}

class GenerateCrmSnapshotFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default generateCrmSnapshot;
